module.exports = __webpack_public_path__ + "static/15-72dcf9d415fd11a70ad15ded99ab470e.jpg";